import { type UseQueryResult, useQuery } from 'react-query';
import * as wealthlaneCustomerServices from '@wealthlane/api-services/wealthlane-customer-service';
import { TradeOrderService } from '@wealthlane/api-services/wealthlane-award-settlement-service';
import { TransferAllocateService } from '@wealthlane/api-services/wealthlane-award-service';

const useGetTransferStatus = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const TransferStatus = useQuery(
    ['getTransferStatus'],
    async () => {
      return await handleRequest(
        TransferAllocateService.getApiAwardApiAppTransferAllocateTransferStatuses()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.displayName ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return TransferStatus;
};

export default useGetTransferStatus;
